import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";

const Arrow = () => (
  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-5-5 5 5-5 5" />
  </svg>
);

export default function Footer() {
  const { t } = useI18n();
  const groups = [
    {
      title: "제품",
      links: [
        { label: t.store || "스토어", to: "/store" },
        { label: t.rental || "복합기 렌탈", to: "/rental" },
        { label: "토너 · 소모품", to: "/store/toner-supplies" },
        { label: "사업자 전용몰", to: "/b2b" },
      ],
    },
    {
      title: "서비스",
      links: [
        { label: t.inquiry || "견적 상담", to: "/consultation" },
        { label: "지역별 렌탈", to: "/rental" },
        { label: "A/S 신청", to: "/consultation?tab=general&type=as#consultation-form" },
        { label: t.compare || "제품 비교", to: "/compare" },
      ],
    },
    {
      title: "안내",
      links: [
        { label: t.reviewLounge || "설치 후기", to: "/community" },
        { label: t.sitemap || "사이트맵", to: "/sitemap" },
        { label: "교환 · 반품 정책", to: "/policy" },
        { label: "로그인", to: "/login" },
      ],
    },
  ];

  return (
    <footer className="dept-footer">
      <div className="dept-footer__contact">
        <div className="dept-footer__contact-inner">
          <div>
            <span>고객센터</span>
            <a href="tel:1600-7542">1600-7542</a>
          </div>
          <p>복합기 도입, 렌탈, 토너 구매와 유지보수를 한 번에 상담하세요.</p>
          <Link to="/consultation">온라인 상담 <Arrow /></Link>
        </div>
      </div>

      <div className="dept-footer__main">
        <div className="dept-footer__brand">
          <Link to="/" aria-label="일광오피스 홈"><strong>ILKWANG</strong><span>OFFICE</span></Link>
          <p>사무기기의 선택부터 설치, 운영, 유지보수까지 책임지는 일광오피스입니다.</p>
        </div>

        <div className="dept-footer__links">
          {groups.map((group) => (
            <section key={group.title}>
              <h2>{group.title}</h2>
              {group.links.map((link) => <Link key={link.label} to={link.to}>{link.label}</Link>)}
            </section>
          ))}
        </div>
      </div>

      <div className="dept-footer__legal">
        <div>
          <strong>일광엔시스</strong>
          <span>대표 강희성</span>
          <span>사업자등록번호 119-24-00329</span>
          <span>통신판매업신고 2019-안양동안-0517호</span>
        </div>
        <div>
          <span>14067 경기도 안양시 동안구 시민대로 230, 평촌아크로타워 A동 403호</span>
          <span>팩스 031-624-4769</span>
          <span>개인정보관리책임자 강희성</span>
        </div>
        <div className="dept-footer__legal-links">
          <Link to="/terms">이용약관</Link>
          <Link to="/privacy">개인정보처리방침</Link>
          <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1192400329" target="_blank" rel="noopener noreferrer">사업자정보확인</a>
        </div>
        <small>© {new Date().getFullYear()} Ilkwang Office. All rights reserved.</small>
      </div>
    </footer>
  );
}
